<template>
  <b-sidebar
    id="sidebar-left"
    bg-variant="dark"
    text-variant="light"
    left
    backdrop
    no-header
  >
    <template>
      <div class="p-3">
        <b-nav vertical>
          <b-nav-item to="/" link-classes="a-white">
            <i class="fa fa-bar-chart mr-2"></i>
            Main
          </b-nav-item>

          <b-nav-item
            v-has-permission.permission="['GRP', 'VI']"
            to="/notification"
            link-classes="a-white"
          >
            <b-icon
              icon="bell-fill"
              style="color: #ffff"
              :class="{ 'b-icon-animation-throb text-danger': hasNotification }"
            ></b-icon>
            Notificações
          </b-nav-item>

          <div class="dropdown-divider"></div>

          <b-nav-item
            v-has-permission.permission="['PAG', 'VI']"
            to="/payment"
            link-classes="a-white"
          >
            <i class="bi bi-credit-card mr-2"></i>
            Contas a receber
          </b-nav-item>
          <b-nav-item
            v-has-permission.permission="['PAG', 'CA']"
            to="/payment/new"
            link-classes="a-white"
          >
            <i class="bi bi-credit-card mr-2"></i>
            Adicionar Conta a receber
          </b-nav-item>

          <div class="dropdown-divider"></div>

          <b-nav-item
            v-has-permission.permission="['PLA', 'VI']"
            to="/plan"
            link-classes="a-white"
          >
            <i class="bi bi-file-earmark-text mr-2"></i>
            Planos
          </b-nav-item>
          <b-nav-item
            v-has-permission.permission="['CAS', 'VI']"
            to="/server"
            link-classes="a-white"
          >
            <i class="bi bi-server mr-2"></i>
            Servidor
          </b-nav-item>
          <b-nav-item
            v-has-permission.permission="['EMP', 'VI']"
            to="/company"
            link-classes="a-white"
          >
            <i class="bi bi-globe mr-2"></i>
            Empresa
          </b-nav-item>

          <b-nav-item
            v-has-permission.permission="['ERP', 'VI']"
            to="/erp"
            link-classes="a-white"
          >
            <i class="bi bi-hdd-stack mr-2"></i>
            ERP
          </b-nav-item>

          <b-nav-item
            v-has-permission.permission="['CHL', 'VI']"
            to="/log"
            link-classes="a-white"
          >
            <i class="bi bi-sliders mr-2"></i>
            Log
          </b-nav-item>

          <b-nav-item
            v-has-permission.permission="['GRP', 'VI']"
            to="/grouppage"
            link-classes="a-white"
          >
            <i class="bi bi-card-list mr-2"></i>
            Grupo de páginas
          </b-nav-item>

          <div class="dropdown-divider"></div>

          <b-nav-item
            v-has-permission.permission="['PRO', 'VI']"
            to="/profile"
            link-classes="a-white"
          >
            <i class="bi-file-earmark-person-fill mr-2"></i>
            Perfil
          </b-nav-item>

          <b-nav-item
            v-has-permission.permission="['USU', 'VI']"
            to="/user"
            link-classes="a-white"
          >
            <i class="bi bi-file-earmark-person mr-2"></i>
            Usuários
          </b-nav-item>

          <b-nav-item
            v-has-permission.permission="['GRP', 'VI']"
            to="/message"
            link-classes="a-white"
          >
            <i class="bi bi-card-list mr-2"></i>
            Mensagem
          </b-nav-item>

          <div class="dropdown-divider"></div>

          <b-nav-item to="/email" link-classes="a-white">
            <i class="bi bi-mailbox mr-2"></i>
            Log broker e-mail
          </b-nav-item>

          <div class="dropdown-divider"></div>

          <b-nav-item @click="exit" link-classes="a-white">
            <i class="fa fa-sign-out mr-2" aria-hidden="true"></i>
            Sair
          </b-nav-item>
        </b-nav>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import localStore from "../../components/extra/LocalStorage";

export default {
  name: "SideBar",
  computed: {
    ...mapGetters({
      isLogged: "isLogged",
      hasNotification: "hasNotification"
    })
  },
  methods: {
    exit() {
      localStore.setToken(null);
      this.logout();
      this.$router.push({ path: "/login", replace: true });
    },
    ...mapActions({
      logout: "logout"
    })
  }
};
</script>

<style>
.b-sidebar {
  top: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/header/SideBar.vue